const images = {
    logo: "/logo.png",
    panda: "/panda.jpg",
    smol: "/smol.jpg",
    fert: "/fert.jpg",
    loading: "/loading.gif",
}

export default images;